import Vue from 'vue'
import LazyVideo from '@/components/global/LazyVideo'

Vue.component('LazyVideo', LazyVideo)
